<template>
    <div class="theme-wrapper">
        <div class="theme-preview cursor-pointer">
            <div class="ayv-portrait-wrapper" @click="selectPressed" :style="{'background-image': `url(${themeImagePath})`}"></div>
        </div>
        <div class="font-bold uppercase text-2xl tracking-wider">{{ title }} <Popover :text="desc"></Popover></div>
        <div class="font-italic">ab {{ price }}€</div>
        <div class="mt-5">
            <button class="btn btn-primary--brand big" @click="selectPressed"><span class="">{{ maxRecordings > 1 ? 'Stimmen' : 'Stimme' }} aufnehmen</span></button>
        </div>
    </div>
</template>

<script>
import Popover from './../../../Components/Popover.vue';

export default {
    components: {
        Popover
    },
    props: {
        desc: String,
        title: String,
        price: Number,
        maxRecordings: Number
    },
    computed: {
        themeImagePath() {
            switch (this.title.toLowerCase()) {
                case 'love':
                    return '/build/public/images/themes/theme_love.png'
                    break;
                case 'family':
                    return '/build/public/images/themes/theme_family.png'
                    break;

                default:
                    return '/build/public/images/themes/theme_classic.png'
                    break;
            }
        }
    },
    methods: {
        /**
         * Select button has been pressed.
         */
        selectPressed() {
            this.$emit('select');
        },

        imageWidth(maxRecordings) {
            return {
                width: (maxRecordings*30) + 'px;'
            }
        }
    }
}
</script>
